<template>
    <app-sercheable-data-table :headers="headers" :search="search" :refresh="refresh">
        <template slot="afterReloadButton" v-if="!readonly">
            <v-btn :to="{ name: 'typeDemandCreate' }" color="primary">{{ $t('label.createTypeDemand') }}</v-btn>
        </template>
        <template slot="items" slot-scope="{item}">
            <router-link :to="{ name: 'typeDemandEdit', params: { id: item.id }}" tag="tr">
                <td style="width:400px">{{ item.name }}</td>
                <td style="width:100px">{{ item.status }}</td>
                <td :title="item.description">{{ item.description | shortenedDescription}}</td>
            </router-link>
        </template>
    </app-sercheable-data-table>
</template>

<script>
// import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import SercheableDataTable from '../../shared/SercheableDataTable';

export default {
    data() {
        return {
            headers: [
                {
                    text: this.$t('label.name'),
                    value: 'name',
                    align: 'left',
                },
                {
                    text: `${this.$t('label.active')}?`,
                    value: 'status',
                    align: 'left',
                },
                {
                    text: this.$t('label.description'),
                    value: 'description',
                    align: 'left',
                    sortable: false,
                },
            ],
        };
    },

    computed: {
        demandTypes() {
            const demandTypes = this.$store.getters.demandTypes;
            demandTypes.forEach((type) => { type.status = type.isActive ? this.$t('label.yes') : this.$t('label.no'); });
            return demandTypes;
        },
        readonly() {
            return !this.$store.getters.isAdmin;
        },
    },

    components: {
        appSercheableDataTable: SercheableDataTable,
    },

    methods: {
        search(filters) {
            return utilities.filterMultiple(this.demandTypes, filters, (demandType, regex) => (
                regex.test(demandType.status) ||
                regex.test(demandType.name) ||
                regex.test(demandType.description)
            ));
        },
        async refresh() {
            await this.$store.dispatch('loadDemandTypes');
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/types/demand/Index.vue